import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { BehaviorSubject, Observable } from 'rxjs';
import { FirebaseDataService } from './firebase-data.service';
import { AngularFirestore } from '@angular/fire/firestore';
import UserCredential = firebase.auth.UserCredential;
import { auth, User } from 'firebase';
import { environment } from '../../../environments/environment';
import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user: User = null;
  $user: BehaviorSubject<User> = new BehaviorSubject<User>(this.user);

  constructor(
    private afAuth: AngularFireAuth,
    private db: FirebaseDataService,
    private afs: AngularFirestore,
    private router: Router,
    private http: HttpClient
  ) {
  }

  static getMessageError(code: string): string {
    switch (code) {
      case 'auth/email-already-exists':
        return 'Correo electrónico en uso.';

      case 'auth/invalid-email':
        return 'Correo electrónico inválido.';

      case 'auth/operation-not-allowed':
        return 'Esta operación no está permitida.';

      case 'auth/weak-password':
        return 'Contraseña muy débil.';

      case 'auth/wrong-password':
        return 'Contraseña incorrecta';

      case 'auth/invalid-password':
        return 'Contraseña inválida, mínimo 6 caracteres';

      case 'auth/invalid-uid':
        return 'Usuario inválido';

      case 'auth/user-disabled':
        return 'Tu usuario ha sido bloqueado';

      case 'auth/user-not-found':
        return 'El usuario no fue encontrado, revise su correo electrónico';

      case 'auth/network-request-failed':
        return 'Error en la conexión';

      case 'auth/email-already-in-use':
        return 'El email ya está en uso';

      default:
        console.log(code);
        return `Pruebe de nuevo. Si el problema persiste contacte con el equipo de soporte: soporte@tecnologiasintech.com`;
    }
  }

  async loginGoogle() {
    try {
      const provider = new auth.GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });

      return this.afAuth.auth.signInWithPopup(provider);
    } catch (err) {
      console.error('Error login with google account:', err);
    }
  }

  async reAuth(email: string, pass: string): Promise<UserCredential> {
    await this.afAuth.user.pipe(take(1)).toPromise();
    return this.afAuth.auth.signInWithEmailAndPassword(email, pass);
  }

  async getCurrentUser(): Promise<firebase.User> {
    if (!this.user) {
      return await this.loadFirebaseUser();
    }
    return this.user;
  }

  async loadFirebaseUser(): Promise<User> {
    return new Promise((resolve) => {
      this.afAuth.user.subscribe((data) => {
        let userData = _.cloneDeep(data);
        if (environment.replaceUID) {
          userData.uid = environment.replaceUID;
        }

        this.user = userData;
        this.$user.next(userData);
        resolve(userData);
      });
    });
  }

  async signOut(): Promise<void> {
    await this.afAuth.auth.signOut();
    localStorage.clear();
    await this.router.navigateByUrl('auth');
  }

  getWhiteList(): Observable<any[]> {
    return this.db.colWithIds$('whitelist', (ref) =>
      ref.where('trash', '==', false)
    );
  }

  getAllWhiteList(): Observable<any[]> {
    return this.db.colWithIds$('whitelist');
  }

  async addToWhitelist(email: string): Promise<void> {
    try {
      const res: any = await this.http
        .post(`${environment.apiBaseURL}/api/users/create`, {
          email: email.trim(),
          password: null
        })
        .pipe(take(1))
        .toPromise();

      if (!res.ok || !res.uid) {
        throw res.error;
      }

      await this.afs.collection('whitelist').add({
        email,
        isRegistered: false,
        trash: false
      });

      AlertService.toastSuccess('Lista de usuarios admitidos actualizada!');
    } catch (e) {
      if (e.code == 'auth/email-already-exists') {

        await this.afs.collection('whitelist').add({
          email,
          isRegistered: true,
          trash: false
        });
        AlertService.toastSuccess('Lista de usuarios admitidos actualizada!');

        return;

      }

      console.error(e);

      let message = AuthService.getMessageError(e.code);
      AlertService.error(message);
    }
  }

  updateWhitelistItem(itemKey: string, item): void {
    this.afs.doc(`whitelist/${itemKey}`).update(item);
  }
}
